import React, { useEffect, useRef, useState } from "react";
import PersonalTrainingFilter from "./components/personal-training";
import DateFilter from "./components/date";
import TrainerFilter from "./components/trainer";
import './style.scss';
import {formatDateAndTime, formatNumberCompact, getAllQueryLocalStorage, removeGivenQueryLocalStorage, startLoader, stopLoader } from "../../lib/utils";
import _ from "lodash";
import EnquiryFilter from "./components/enquiry-filter";
import { saveAs } from "file-saver";
import FollowUpFilter from "./components/follow-up";
import AdsFilter from "./components/ads";
import PaymentMode from "../payment-mode";
import ExpenseFilter from "./components/expense";
import AppointmentFilter from "./components/appointment";
import Parameter from "./components/parameter";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import MemberShipFilter from "./components/membership";
import PaymentsFilter from "./components/payments";
import ContentFilter from "./components/content";
import PlannerFilter from "./components/planner";
import BranchFilter from "./components/branch";
import GymFilter from "./components/gym";
import { useLocation } from 'react-router-dom';
import { useQueryParams } from "../../lib/useQueryParams";
import MemberSearch from "./components/member-search";
import EmployeeFilter from "./components/employee";
import MemberFilter from "./components/member";
import Status from "./components/status";
import Toast from "../../lib/toast";
import { downloadMemberships } from "../../features/memberships/helper/api";
import { isAuthenticated } from "../../auth";
import Gender from "./components/gender";
import Birthday from "./components/birthday";


const SearchFilter = (props={
  Hot:0,
  Warm:0,
  Cold:0,
  userFollowupCount:0,
  totalFollowupCount:0,
  gymInfo:null
}) => {
  const gymInfo = props.gymInfo;
  const {user,token} = isAuthenticated();
  const location = useLocation();
  const {addQueryParam,addAllQueryParams,getAllQueryParams,removeQueryParam,removeGivenQueryParams} = useQueryParams();
  const history = useHistory();
  const [isFilterOpen, setFilterOpen] = useState(false);
  const [gymSelected, setGymSelected] = useState();
  const [filterType,setFilterType] = useState();
  const count = useRef(0);
  const [searchInput, setSearchInput] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);
  const [isReset,setReset]=useState(false);
  const [isMembershipDropDownOpen, setMembershipDropDownOpen] = useState(false);
  const [selectedMembershipType, setSelectedMembershipType] = useState("All Membership");
  const [selectedPaymentType, setSelectedPaymentType] = useState("All Payments");
  const [isPaymentDropDownOpen, setPaymentDropDownOpen] = useState(false);

  const [isMembershipRenewalAvailable, setMembershipRenewalAvailability] = useState(false);
  const [isButtonLock,setButtonLock] = useState(false);


  const handleResetState = () =>{
    setReset(!isReset)
  } 

  const handleDownLoadMembership = async () => {
    try {
      if(isButtonLock){
        new Toast({
          type:'warning',
          message:"Already downloading please wait...",
          duration:3000
        });
        return;
      }
      let params = {};

      if(localStorage.getItem("branchId")) params.branchIDs = [localStorage.getItem("branchId")]

      let queryParams = getAllQueryParams();

      params = {
        ...params,
        ...queryParams
      }

      if(params.search){
        params.q = params.search;
        delete params.search;
      }
      setButtonLock(true)
      new Toast({
        type:'info',
        message:"Downloading file please wait...",
        duration:1000
      });
      // alert(user._id)
      const response = await downloadMemberships(user._id,token,params);
      // alert(JSON.stringify(response))

      if (response.error) {
        new Toast({
          type:'error',
          message:"Failed to download file",
          duration:3000
        });
        setButtonLock(false);
        await stopLoader()
        return;
      }

       new Toast({
        type:'info',
        message:"Saving file ...",
        duration:1000
      });

      saveAs(response, `${gymInfo.gym[0].name}`.toLowerCase().split(" ").join("_")+"_"+formatDateAndTime(new Date()).replace(/,/g, "").split(" ").join("_")+".xlsx"); // Save file to user’s computer
    } catch (error) {
      console.error("Download error:", error);
    }
    await stopLoader();
    setButtonLock(false);
  };


  const ApplyFilter = () =>{
    // if(props.filterSection == "follow-up-filter"){
    //   const queryParams = new URLSearchParams(location.search);
    //   const count = Array.from(queryParams.keys()).length;

    //   if(count){
    //     toggleFilterView()
    //     props.reload();
    //   }
    // }else{
      try{
       toggleFilterView()
       let params = getAllQueryLocalStorage();
       if(params){
        addAllQueryParams(params);
       }
      }catch(error){

      }
    //}
  }

  const ClearFilter = () =>{
    try{
        setReset(true);
        toggleFilterView();
        const queries = getAllQueryLocalStorage();
        removeGivenQueryParams(queries);
        removeGivenQueryLocalStorage(queries);
        if(props.reload) props.reload();
    }catch(error){

    }
  }

  const toggleMembershipDropDown = () => {
    setMembershipDropDownOpen(!isMembershipDropDownOpen)
  }

  const togglePaymentDropDown = () => {
    setPaymentDropDownOpen(!isPaymentDropDownOpen);
  }

  const getStatus = (status) => {
    props.getStatus(status)
  } 

  // useEffect(() => {
  //   const handleClick = () => {
  //     setFilterOpen(false);
  //   };

  //   document.addEventListener("click", handleClick);
  //   return () => document.removeEventListener("click", handleClick);
  // }, []);

  useEffect(() => {
  const handleClick = (e) => {
 
    if (e.target.closest(".flatpickr-calendar")) return;

    setFilterOpen(false);
  };

  document.addEventListener("click", handleClick);
  return () => document.removeEventListener("click", handleClick);
}, []);

  const getAllFilteredItems = () => {
    return(
      // window.innerWidth > 767 && isMembershipRenewalAvailable ? "84%" : window.innerWidth > 767 && (props.moreAction == "Select-Membership" || props.moreAction == "payment-action") ? "50%" : ""
      <div className="filtered-items-list d-flex" style={{width: "auto"}}>
        <div className="d-flex">
          {
            props.filterSection == "member-filter" && [  
              <div onClick={()=>props.handleCurrentFilterType("WPK")} className={`filtered-item filtered-item-actionable space-between d-flex flex-item m-l-12 ${props.filterStatus == "WPK" && "filtered-item-actionable-active"}`}>
                <div className="flex-item m-r-12" style={{textAlign:"center"}}>
                  <p className="fs-12 font-weight-600" style={{lineHeight:"10px", whiteSpace:"nowrap"}}>WPK</p>
                  <p className="m-t-6 font-weight-700 color-red" style={{lineHeight:"12px", whiteSpace:"nowrap"}}>{props.memberDataInfo.wpk ? props.memberDataInfo.wpk : 0}</p>
                </div>
              </div>,
              <div className="flex-item m-l-12" style={{width:"1px", height:"40px", background:"#0088cc"}}/>,
              <div onClick={()=>props.handleCurrentFilterType("All")} className={`filtered-item filtered-item-actionable space-between d-flex flex-item m-l-12 ${props.filterStatus == "All" && "filtered-item-actionable-active"}`}>
                <div className="flex-item m-r-12" style={{textAlign:"center"}}>
                  <p className="fs-12 font-weight-600" style={{lineHeight:"10px", whiteSpace:"nowrap"}}>Total</p>
                  <p className="m-t-6 font-weight-700 color-red" style={{lineHeight:"12px", whiteSpace:"nowrap"}}>{props.memberDataInfo.total ? props.memberDataInfo.total : 0}</p>
                </div>
              </div>,
              <div onClick={()=>props.handleCurrentFilterType("Active")} className={`filtered-item filtered-item-actionable space-between d-flex flex-item m-l-12 ${props.filterStatus == "Active" && "filtered-item-actionable-active"}`}>
                <div className="flex-item m-r-12" style={{textAlign:"center"}}>
                  <p className="fs-12 font-weight-600" style={{lineHeight:"10px", whiteSpace:"nowrap"}}>Active</p>
                  <p className="m-t-6 font-weight-700 color-red" style={{lineHeight:"12px", whiteSpace:"nowrap"}}>{props.memberDataInfo.active ? props.memberDataInfo.active : 0}</p>
                </div>
              </div>,
              // <div onClick={()=>props.handleCurrentFilterType("Expiry")} className={`filtered-item filtered-item-actionable space-between d-flex flex-item m-l-12 ${props.filterStatus == "Expiry" && "filtered-item-actionable-active"}`}>
              //   <div className="flex-item m-r-12" style={{textAlign:"center"}}>
              //     <p className="fs-12 font-weight-600" style={{lineHeight:"10px", whiteSpace:"nowrap"}}>Expiry</p>
              //     <p className="m-t-6 font-weight-700 color-red" style={{lineHeight:"12px", whiteSpace:"nowrap"}}>{props.memberDataInfo.active ? props.memberDataInfo.active : 0}</p>
              //   </div>
              // </div>,
              // <div onClick={()=>props.handleCurrentFilterType("Balance-Due")} className={`filtered-item filtered-item-actionable space-between d-flex flex-item m-l-12 ${props.filterStatus == "Balance-Due" && "filtered-item-actionable-active"}`}>
              //   <div className="flex-item m-r-12" style={{textAlign:"center"}}>
              //     <p className="fs-12 font-weight-600" style={{lineHeight:"10px", whiteSpace:"nowrap"}}>Balance Due</p>
              //     <p className="m-t-6 font-weight-700 color-red" style={{lineHeight:"12px", whiteSpace:"nowrap"}}>{props.memberDataInfo.active ? props.memberDataInfo.active : 0}</p>
              //   </div>
              // </div>,
              <div onClick={()=>props.handleCurrentFilterType("Upcoming")}  className={`filtered-item filtered-item-actionable space-between d-flex flex-item m-l-12  ${props.filterStatus == "Upcoming" && "filtered-item-actionable-active"}`}>
                <div className="flex-item m-r-12" style={{textAlign:"center"}}>
                  <p className="fs-12 font-weight-600" style={{lineHeight:"10px", whiteSpace:"nowrap"}}>Upcoming</p>
                  <p className="m-t-6 font-weight-700 color-red" style={{lineHeight:"12px", whiteSpace:"nowrap"}}>{props.memberDataInfo.upcoming || 0}</p>
                </div>
              </div>,
              <div onClick={()=>props.handleCurrentFilterType("Past")} className={`filtered-item filtered-item-actionable space-between d-flex flex-item m-l-12 ${props.filterStatus == "Past" && "filtered-item-actionable-active"}`}>
                <div className="flex-item m-r-12" style={{textAlign:"center"}}>
                  <p className="fs-12 font-weight-600" style={{lineHeight:"10px", whiteSpace:"nowrap"}}>Past</p>
                  <p className="m-t-6 font-weight-700 color-red" style={{lineHeight:"12px", whiteSpace:"nowrap"}}>{props.memberDataInfo.past ? props.memberDataInfo.past : 0}</p>
                </div>
              </div>
              // <div className="filtered-item filtered-item-actionable space-between d-flex flex-item m-l-12">
              //   <div className="flex-item m-r-12" style={{textAlign:"center"}}>
              //     <p className="fs-12 font-weight-600" style={{lineHeight:"10px", whiteSpace:"nowrap"}}>Potential Leads</p>
              //     <p className="m-t-6 font-weight-700 color-red" style={{lineHeight:"12px", whiteSpace:"nowrap"}}>24</p>
              //   </div>
              // </div>,
              ,<div onClick={()=>props.handleCurrentFilterType("Today-Attendance")} className={`filtered-item filtered-item-actionable space-between d-flex flex-item m-l-12 ${props.filterStatus == "Today-Attendance" && "filtered-item-actionable-active"}`}>
                <div className="flex-item m-r-12" style={{textAlign:"center"}}>
                  <p className="font-weight-600 fs-12" style={{lineHeight:"12px", whiteSpace:"nowrap"}}>Attendance</p>
                  {/* {(props.memberDataInfo.attendance && props.memberDataInfo.attendance  == "loading")?<p className="fs-10 color-red font-weight-600 m-t-2">Loading ...</p>: */}
                  <p className="m-t-6 font-weight-700 color-red" style={{lineHeight:"12px", whiteSpace:"nowrap"}}>{props.memberDataInfo.attendance ? props.memberDataInfo.attendance : 0}</p>
                  {/* } */}
                </div>
              </div>
            ]
          }
          {
            props.filterSection == "planner-filter" && (
              <div className="d-flex flex-item">
                <div onClick={()=>props.switchPlannerType("nutrition")} className={`filtered-item filtered-item-actionable space-between d-flex flex-item ${props.filterPlannerType == "nutrition" && "filtered-item-actionable-active"}`}>
                  <div className="flex-item m-r-12" style={{textAlign:"center"}}>
                    <p className="fs-12 font-weight-600" style={{lineHeight:"10px", whiteSpace:"nowrap"}}>Nutrition</p>
                    <p className="m-t-6 font-weight-700 color-red" style={{lineHeight:"12px", whiteSpace:"nowrap"}}>{props.filteredCount.nutrition}</p>
                  </div>
                </div>
                <div onClick={()=>props.switchPlannerType("day")} className={`filtered-item filtered-item-actionable space-between d-flex flex-item m-l-12 ${props.filterPlannerType == "day" && "filtered-item-actionable-active"}`}>
                  <div className="flex-item m-r-12" style={{textAlign:"center"}}>
                    <p className="fs-12 font-weight-600" style={{lineHeight:"10px", whiteSpace:"nowrap"}}>Day</p>
                    <p className="m-t-6 font-weight-700 color-red" style={{lineHeight:"12px", whiteSpace:"nowrap"}}>{props.filteredCount.weekday}</p>
                  </div>
                </div>
                <div onClick={()=>props.switchPlannerType("workout")} className={`filtered-item filtered-item-actionable space-between d-flex flex-item m-l-12 ${props.filterPlannerType == "workout" && "filtered-item-actionable-active"}`}>
                  <div className="flex-item m-r-12" style={{textAlign:"center"}}>
                    <p className="fs-12 font-weight-600" style={{lineHeight:"10px", whiteSpace:"nowrap"}}>Calendar</p>
                    <p className="m-t-6 font-weight-700 color-red" style={{lineHeight:"12px", whiteSpace:"nowrap"}}>{props.filteredCount.calendar}</p>
                  </div>
                </div>
                <div onClick={()=>props.switchPlannerType("fitness")} className={`filtered-item filtered-item-actionable space-between d-flex flex-item m-l-12 ${props.filterPlannerType == "fitness" && "filtered-item-actionable-active"}`}>
                  <div className="flex-item m-r-12" style={{textAlign:"center"}}>
                    <p className="fs-12 font-weight-600" style={{lineHeight:"10px", whiteSpace:"nowrap"}}>Fitness</p>
                    <p className="m-t-6 font-weight-700 color-red" style={{lineHeight:"12px", whiteSpace:"nowrap"}}>{props.filteredCount.fitness}</p>
                  </div>
                </div>
              </div>
            )
          }

          {/* {console.log(props.filterMembershipPlansInfo)} */}

          {
            props.filterSection == "plan-membership-filter" && (
              <div className="d-flex flex-item">
                <div onClick={()=>props.switchMembershipType("All")} className={`filtered-item filtered-item-actionable space-between d-flex flex-item ${props.selectedPlanMembershipType == "All" && "filtered-item-actionable-active"}`}>
                  <div className="flex-item m-r-12" style={{textAlign:"center"}}>
                    <p className="fs-12 font-weight-600" style={{lineHeight:"10px", whiteSpace:"nowrap"}}>All</p>
                    <p className="m-t-6 font-weight-700 color-red" style={{lineHeight:"12px", whiteSpace:"nowrap"}}>{props.filterMembershipPlansInfo && props.filterMembershipPlansInfo.allCount ?props.filterMembershipPlansInfo.allCount : 0}</p>
                  </div>
                </div>
                <div onClick={()=>props.switchMembershipType("GymWorkout")} className={`filtered-item filtered-item-actionable space-between d-flex flex-item m-l-12 ${props.selectedPlanMembershipType == "GymWorkout" && "filtered-item-actionable-active"}`}>
                  <div className="flex-item m-r-12" style={{textAlign:"center"}}>
                    <p className="fs-12 font-weight-600" style={{lineHeight:"10px", whiteSpace:"nowrap"}}>Gym Workout</p>
                    <p className="m-t-6 font-weight-700 color-red" style={{lineHeight:"12px", whiteSpace:"nowrap"}}>{props.filterMembershipPlansInfo && props.filterMembershipPlansInfo.gymWorkout ?props.filterMembershipPlansInfo.gymWorkout : 0}</p>
                  </div>
                </div>
                <div onClick={()=>props.switchMembershipType("PersonalTraining")} className={`filtered-item filtered-item-actionable space-between d-flex flex-item m-l-12 ${props.selectedPlanMembershipType == "PersonalTraining" && "filtered-item-actionable-active"}`}>
                  <div className="flex-item m-r-12" style={{textAlign:"center"}}>
                    <p className="fs-12 font-weight-600" style={{lineHeight:"10px", whiteSpace:"nowrap"}}>Personal Training</p>
                    <p className="m-t-6 font-weight-700 color-red" style={{lineHeight:"12px", whiteSpace:"nowrap"}}>{props.filterMembershipPlansInfo && props.filterMembershipPlansInfo.personalTraining ?props.filterMembershipPlansInfo.personalTraining : 0}</p>
                  </div>
                </div>
                <div onClick={()=>props.switchMembershipType("GroupEx")} className={`filtered-item filtered-item-actionable space-between d-flex flex-item m-l-12 ${props.selectedPlanMembershipType == "GroupEx" && "filtered-item-actionable-active"}`}>
                  <div className="flex-item m-r-12" style={{textAlign:"center"}}>
                    <p className="fs-12 font-weight-600" style={{lineHeight:"10px", whiteSpace:"nowrap"}}>GroupEx</p>
                    <p className="m-t-6 font-weight-700 color-red" style={{lineHeight:"12px", whiteSpace:"nowrap"}}>{props.filterMembershipPlansInfo && props.filterMembershipPlansInfo.groupEX ?props.filterMembershipPlansInfo.groupEX : 0}</p>
                  </div>
                </div>
                <div onClick={()=>props.switchMembershipType("LybertyMembership")} className={`filtered-item filtered-item-actionable space-between d-flex flex-item m-l-12 ${props.selectedPlanMembershipType == "LybertyMembership" && "filtered-item-actionable-active"}`}>
                  <div className="flex-item m-r-12" style={{textAlign:"center"}}>
                    <p className="fs-12 font-weight-600" style={{lineHeight:"10px", whiteSpace:"nowrap"}}>Lyberty Membership</p>
                    <p className="m-t-6 font-weight-700 color-red" style={{lineHeight:"12px", whiteSpace:"nowrap"}}>{props.filterMembershipPlansInfo && props.filterMembershipPlansInfo.lybertyMembership ?props.filterMembershipPlansInfo.lybertyMembership : 0}</p>
                  </div>
                </div>
              </div>
            )
          }

          {
            props.filterSection == "enquiry-action" && (
              <div className="d-flex flex-item">
                <div onClick={()=>props.downloadEnquiryExcel()} className="filtered-item filtered-item-actionable space-between d-flex flex-item">
                  <div className="flex-item d-flex" style={{textAlign:"center"}}>
                    <svg className="flex-item svg-fill m-r-8" width="18" height="18" viewBox="0 0 34 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M32.0586 29.48L32.3633 29.5112C33.0463 29.6515 33.5586 30.2555 33.5586 30.98C33.5586 31.7045 33.0463 32.3085 32.3633 32.4487L32.0586 32.48H1.5C0.671573 32.48 0 31.8084 0 30.98C0 30.1516 0.671573 29.48 1.5 29.48H32.0586Z" fill="#0088DA"/>
                      <path d="M5.60548 13.6735C6.12041 13.1642 6.91203 13.1028 7.4922 13.4899L7.72658 13.6852L16.7461 22.775L25.8438 13.7555C26.4318 13.1721 27.3814 13.1753 27.9649 13.7633C28.5482 14.3513 28.5448 15.3009 27.957 15.8844L17.7969 25.9664C17.5146 26.2461 17.1318 26.4016 16.7344 26.4C16.3366 26.3985 15.956 26.2371 15.6758 25.9547L5.59376 15.7946L5.40236 15.5602C5.02085 14.9765 5.09114 14.1838 5.60548 13.6735Z" fill="#0088DA"/>
                      <path d="M15.2793 21.8203V1.5C15.2793 0.671573 15.9509 0 16.7793 0C17.6077 0 18.2793 0.671573 18.2793 1.5V21.8203C18.2791 22.6486 17.6076 23.3203 16.7793 23.3203C15.951 23.3203 15.2795 22.6486 15.2793 21.8203Z" fill="#0088DA"/>
                    </svg>
                    <p className="fs-18 flex-item font-weight-700 m-r-12" style={{lineHeight:"10px", whiteSpace:"nowrap", color:"#0088da"}}>.xlsx</p>
                  </div>
                </div>
              </div>
            )
          }

          {/* {
            filteredItems.map((item, index) => {
              return(
                <div className="filtered-item space-between d-flex flex-item m-l-12" style={{background: props.isSticky ? "#f5f5f5" : "#ffffff"}}>
                  <div className="flex-item m-r-12">
                    <p className="fs-10 color-grey-04" style={{lineHeight:"10px", whiteSpace:"nowrap"}}>{item.itemType}</p>
                    <p className="fs-12 m-t-4" style={{lineHeight:"12px", whiteSpace:"nowrap"}}>{item.itemType == "Status" ? ( item.itemValue == true ? "Active" : "Inactive") : item.itemValue}</p>
                  </div>
                  <div className="clear-filter-button bg-grey-08 flex-item d-flex">
                    <svg className="flex-item margin-auto svg-stroke" width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 14L14.5 1M14.5 14L1.5 1" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>   
              )
            })
          } */}
        </div>
      </div>
    )
  }

  const convertibilityType = (hot=0, warm=0, cold=0) => {
    return(
      <div className="d-flex w-full h-full space-between">
        <div className="flex-item d-flex">
          <svg className="flex-item m-r-6" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.42383 7.71289H10.1361M5.42383 9.56366H10.1361M7.44306 7.71289C7.8919 7.82481 8.7896 8.21828 8.7896 9.3952C8.7896 11.4144 6.09652 11.4144 6.09652 11.4144C6.09652 11.4144 7.44306 12.5925 9.46229 13.0979" stroke="#DF2B03" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.7805 16.3672C11.819 16.3672 14.7036 14.9387 14.7036 11.7587C14.7036 8.30296 12.9728 5.99873 9.51127 4.27026L10.8728 2.51873C10.9422 2.40383 10.9798 2.27262 10.9819 2.13844C10.9841 2.00426 10.9506 1.87191 10.8849 1.75488C10.8192 1.63785 10.7237 1.54031 10.6081 1.47221C10.4925 1.40411 10.3608 1.36787 10.2267 1.36719H5.33435C5.20043 1.36858 5.06926 1.40526 4.95405 1.47353C4.83884 1.5418 4.74367 1.63924 4.67813 1.75603C4.6126 1.87282 4.57902 2.00482 4.58079 2.13873C4.58256 2.27263 4.6196 2.40371 4.68819 2.51873L6.04973 4.2818C2.58819 6.0218 0.857422 8.32603 0.857422 11.7818C0.857422 14.9387 3.74204 16.3672 7.7805 16.3672Z" stroke="#DF2B03" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <p className="flex-item"><span className="color-red font-weight-700" style={{lineHeight:"14px"}}>{hot}</span> Hot</p>
        </div>
        <div className="flex-item" style={{width:"1px", height:"25px", background:"#d0d0d0"}} />
        <div className="flex-item d-flex">
          <svg className="flex-item m-r-6" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.42383 7.71289H10.1361M5.42383 9.56366H10.1361M7.44306 7.71289C7.8919 7.82481 8.7896 8.21828 8.7896 9.3952C8.7896 11.4144 6.09652 11.4144 6.09652 11.4144C6.09652 11.4144 7.44306 12.5925 9.46229 13.0979" stroke="#DD9F00" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.7805 16.3672C11.819 16.3672 14.7036 14.9387 14.7036 11.7587C14.7036 8.30296 12.9728 5.99873 9.51127 4.27026L10.8728 2.51873C10.9422 2.40383 10.9798 2.27262 10.9819 2.13844C10.9841 2.00426 10.9506 1.87191 10.8849 1.75488C10.8192 1.63785 10.7237 1.54031 10.6081 1.47221C10.4925 1.40411 10.3608 1.36787 10.2267 1.36719H5.33435C5.20043 1.36858 5.06926 1.40526 4.95405 1.47353C4.83884 1.5418 4.74367 1.63924 4.67813 1.75603C4.6126 1.87282 4.57902 2.00482 4.58079 2.13873C4.58256 2.27263 4.6196 2.40371 4.68819 2.51873L6.04973 4.2818C2.58819 6.0218 0.857422 8.32603 0.857422 11.7818C0.857422 14.9387 3.74204 16.3672 7.7805 16.3672Z" stroke="#DD9F00" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <p className="flex-item"><span className="font-weight-700" style={{color:"#DD9F00", lineHeight:"14px"}}>{warm}</span> Warm</p>
        </div>
        <div className="flex-item" style={{width:"1px", height:"25px", background:"#d0d0d0"}} />
        <div className="flex-item d-flex">
          <svg className="flex-item m-r-6" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.42383 7.71289H10.1361M5.42383 9.56366H10.1361M7.44306 7.71289C7.8919 7.82481 8.7896 8.21828 8.7896 9.3952C8.7896 11.4144 6.09652 11.4144 6.09652 11.4144C6.09652 11.4144 7.44306 12.5925 9.46229 13.0979" stroke="#0088da" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.7805 16.3672C11.819 16.3672 14.7036 14.9387 14.7036 11.7587C14.7036 8.30296 12.9728 5.99873 9.51127 4.27026L10.8728 2.51873C10.9422 2.40383 10.9798 2.27262 10.9819 2.13844C10.9841 2.00426 10.9506 1.87191 10.8849 1.75488C10.8192 1.63785 10.7237 1.54031 10.6081 1.47221C10.4925 1.40411 10.3608 1.36787 10.2267 1.36719H5.33435C5.20043 1.36858 5.06926 1.40526 4.95405 1.47353C4.83884 1.5418 4.74367 1.63924 4.67813 1.75603C4.6126 1.87282 4.57902 2.00482 4.58079 2.13873C4.58256 2.27263 4.6196 2.40371 4.68819 2.51873L6.04973 4.2818C2.58819 6.0218 0.857422 8.32603 0.857422 11.7818C0.857422 14.9387 3.74204 16.3672 7.7805 16.3672Z" stroke="#0088da" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <p className="flex-item"><span className="color-blue font-weight-700" style={{lineHeight:"14px"}}>{cold}</span> Cold</p>
        </div>
      </div>
    )
  }

  const toggleFilterView = (type) => {
    setFilterOpen(!isFilterOpen)
  }

  const handleFocusSearchField = (state) => {
    let searchContainer = document.getElementById("search-container");
    if(!props.isSticky){
      if(searchContainer && state == "active"){
        searchContainer.style.outline = "1px solid var(--darkBlue)";
        searchContainer.style.backgroundColor = "#FFFFFF";
      }
      if(searchContainer && state == "in-active"){
        searchContainer.style.outline = "none";
        searchContainer.style.backgroundColor = "#F7FDFF";
      }
    }
  }

  const handleSearchInput = (e) => {
    // if(props.filterSection == "dashboard-search"){
      // if (/^\d{0,10}$/.test(e.target.value)) {
      //   setSearchInput(e.target.value);
      // }else{
      //   alert("Phone number cannot exceed 10 digits")
      // }
    // }
    if(props.searchLocation == "modal-search"){
      setSearchInput(e.target.value);
      if(props.searchingData) props.searchingData(e.target.value);
    }else if(props.filterSection == "gym-filter"){
      setSearchInput(e.target.value);
      if(props.searchingData) props.searchingData(e.target.value);
    } else{
      setSearchInput(e.target.value);
      if(e.target.value) addQueryParam("search",e.target.value);
      else removeQueryParam("search")
      if(props.searchingData) props.searchingData(e.target.value);
    }
  }

  // const getStatus = (status) => {
  //   setFilteredItems((prevItems = []) => {
  //     if (!Array.isArray(prevItems)) return [{ itemType: "Status", itemValue: status }];
  
  //     const index = prevItems.findIndex(item => item.itemType === "Status");
  
  //     if (index !== -1) {
  //       const updatedItems = [...prevItems];
  //       updatedItems[index] = { ...updatedItems[index], itemValue: status };
  //       return updatedItems;
  //     }
  
  //     return [...prevItems, { itemType: "Status", itemValue: status }];
  //   });

  // };

  const handleParameterType = (data) => {
    props.handleParameterType(data);
  }

  const handleSelectMembershipType = (value = "All Membership") => {
    setSelectedMembershipType(value)
    if(value != "All Membership") addQueryParam("type",`${value}`.trim().split(" ").join(''))
    else removeQueryParam('type');
  }

  const handleSelectPaymentType = (value="") => {
     if(value == "All Payments" || !value) removeQueryParam("type");
    else addQueryParam("type",value);
    setSelectedPaymentType(value)
  }

  const selectMembershipView = () => {
    return(
      <div onClick={()=>toggleMembershipDropDown()} className="d-flex flex-item m-r-12 p-l-16 p-r-16 cursor-pointer" style={{borderRadius:"20px", height:"40px", background:"var(--red)", position:"relative"}}>
        <p className="flex-item" style={{color:"#ffffff", fontWeight:700}}>{selectedMembershipType == "Gym Workout" ? "Fitness Membership" : selectedMembershipType}</p>
        <svg className="flex-item m-l-18" style={{transition:"180ms", transform: isMembershipDropDownOpen ? "rotate(180deg)" : "rotate(0deg)" }} width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L7 7L13 1" stroke="white" stroke-width="2" stroke-linecap="round"/>
        </svg>
        {
          isMembershipDropDownOpen && (
            <div className="select-membership-dropdown cursor-pointer scaleFromTopToBottom">
              <div onClick={()=>handleSelectMembershipType("All Membership")} className="membership-dropdown-item">
                <p className="flex-item font-weight-600">All Membership</p>
              </div>
              <div onClick={()=>handleSelectMembershipType("Gym Workout")} className="membership-dropdown-item">
                <p className="flex-item font-weight-600">Fitness Membership</p>
              </div>
              <div onClick={()=>handleSelectMembershipType("Personal Training")} className="membership-dropdown-item">
                <p className="flex-item font-weight-600">Personal Training</p>
              </div>
              <div onClick={()=>handleSelectMembershipType("Group Ex")} className="membership-dropdown-item">
                <p className="flex-item font-weight-600">Group Ex</p>
              </div>
              <div onClick={()=>handleSelectMembershipType("Lyberty Membership")} className="membership-dropdown-item">
                <p className="flex-item font-weight-600">Lyberty Membership</p>
              </div>
            </div>
          )
        }
      </div>
    )
  }

  const selectPaymentView = () => {
    return(
      <div onClick={()=>togglePaymentDropDown()} className="d-flex flex-item m-r-12 p-l-16 p-r-16 cursor-pointer" style={{borderRadius:"20px", height:"40px", background:"var(--red)", position:"relative"}}>
        <p className="flex-item" style={{color:"#ffffff", fontWeight:700}}>{selectedPaymentType}</p>
        <svg className="flex-item m-l-18" style={{transition:"180ms", transform: isPaymentDropDownOpen ? "rotate(180deg)" : "rotate(0deg)" }} width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L7 7L13 1" stroke="white" stroke-width="2" stroke-linecap="round"/>
        </svg>
        {
          isPaymentDropDownOpen && (
            <div className="select-membership-dropdown cursor-pointer scaleFromTopToBottom">
              <div onClick={()=>handleSelectPaymentType("All Payments")} className="membership-dropdown-item">
                <p className="flex-item font-weight-600">All Payments</p>
              </div>
              <div onClick={()=>handleSelectPaymentType("Balance Payments")} className="membership-dropdown-item">
                <p className="flex-item font-weight-600">Balance Payments</p>
              </div>
              <div onClick={()=>handleSelectPaymentType("Cancelled Invoice")} className="membership-dropdown-item">
                <p className="flex-item font-weight-600">Cancelled Invoice</p>
              </div>
              <div onClick={()=>handleSelectPaymentType("Approval Requests")} className="membership-dropdown-item">
                <p className="flex-item font-weight-600">Approval Requests</p>
              </div>
            </div>
          )
        }
      </div>
    )
  }

  const plannerFilterStatus = (filters) => {
    props.filterActions(filters);
  }


  useEffect(()=>{
    console.log(props);
  },[props])



  useEffect(() => {  
    if(props.filteredItems){
      props.filteredItems(filteredItems)
    }
  }, [filteredItems]);

 
  useEffect(()=>{
    if(props.isItemSelected){
      setSearchInput('')
    }
  },[props.isItemSelected])

  useEffect(()=>{
    console.log(props.count);
    count.current=props.count?props.count:0;
  },[props])

  useEffect(()=>{
    let params = getAllQueryParams();
    if(params.search){
      setSearchInput(params.search);
      document.getElementById("search").value = params.search;
    }
  },[]);


  // useEffect(() => {
  //   if(props.filterSection == "member-filter"){
  //     getStatus(true);
  //   }
  // },[props.filterSection == "member-filter"])


  return(
    <div className="search-filter-bar" style={{zIndex: props.isSticky && 20, backgroundColor: props.isSticky ? "#FFFFFF" : "", boxShadow: props.isSticky ? "0px 0px 12px 0px rgba(5, 80, 117, 0.15)" : "", borderRadius: isFilterOpen ? "0 0 12px 12px" : "0", paddingBottom: isFilterOpen && "0px"}}>
      <div className="w-full d-flex space-between">
        {
          props.isSearchEnabled && [
            <div id="search-container" className="search-container d-flex space-between" style={{backgroundColor: props.isSticky ? "#FFFFFF" : "", paddingLeft: props.isSticky ? "0px" : "", transition:"180ms", width: props.isFilterEnabled && (props.moreAction == "Select-Membership" || props.moreAction == "payment-action") ? "" : !props.isFilterEnabled ? "100%" : filteredItems == 0 && window.innerWidth > 767 ? "96%" : "", marginRight: !props.isFilterEnabled ? "0" : ""}}>
              <div className="d-flex w-full">
                <svg className="flex-item m-r-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 21L16.657 16.657M16.657 16.657C17.3999 15.9141 17.9892 15.0322 18.3912 14.0615C18.7933 13.0909 19.0002 12.0506 19.0002 11C19.0002 9.9494 18.7933 8.90908 18.3913 7.93845C17.9892 6.96782 17.3999 6.08589 16.657 5.343C15.9141 4.60011 15.0322 4.01082 14.0616 3.60877C13.0909 3.20673 12.0506 2.99979 11 2.99979C9.94942 2.99979 8.90911 3.20673 7.93848 3.60877C6.96785 4.01082 6.08591 4.60011 5.34302 5.343C3.84269 6.84333 2.99982 8.87821 2.99982 11C2.99982 13.1218 3.84269 15.1567 5.34302 16.657C6.84335 18.1573 8.87824 19.0002 11 19.0002C13.1218 19.0002 15.1567 18.1573 16.657 16.657Z" stroke="#6D6D6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <input id="search" onClick={()=>handleFocusSearchField("active")} onMouseLeave={()=>handleFocusSearchField("in-active")} onInput={_.debounce(handleSearchInput,700)} type="text" placeholder={`Search “${props.searchType}”`} className="flex-item search-input" style={{width: filteredItems == 0 && window.innerWidth > 767 ? "96%" : props.isSticky ? "85%" : props.searchFieldWidth ? props.searchFieldWidth : "100%"}} />
              </div>
              { 
                (!props.isSticky) && (
                  <div className="d-flex flex-item h-full" style={{visibility: props.isSticky ? "hidden" : "visible"}}>
                    {
                      props.filterSection != "member-filter" && [
                        <div className="st-line flex-item m-r-8 m-l-8"/>,
                        <div className="total-items-container d-flex">
                          <p className="flex-item font-weight-700 color-dark-blue" style={{whiteSpace:"nowrap"}}>{props.count?parseInt(props.count):0}</p>
                        </div>
                      ]
                    }
                  </div>
                )
              }

              {
                props.filterSection == "dashboard-search" && searchInput.length > 0 && (
                  <MemberSearch searchInput={searchInput} />
                )
              }

            </div>,
            props.filterSection == "follow-up-filter" && isMembershipRenewalAvailable && window.innerWidth > 767 && (
              <div className="convertibility-type-container bg-white d-flex">
                {convertibilityType(props.Hot, props.Warm, props.Cold)}
              </div>
            )
          ]
        }

        <div className="d-flex" style={{width: window.innerWidth > 767 && props.moreAction ? "65%" :  window.innerWidth > 767 && isMembershipRenewalAvailable ? "33%" : window.innerWidth > 767 && filteredItems.length == 0 ? "auto" : window.innerWidth > 767 ? "auto" : "auto", justifyContent:"flex-end"}}>
          {
            window.innerWidth > 767 && (
              getAllFilteredItems()
            )
          }
          {
            props.isFilterEnabled && (
              <div className="d-flex flex-item m-l-12">
                 {
                  (props.moreAction == "Select-Membership" && window.innerWidth > 767) && (
                    <div onClick={()=>!isButtonLock ? handleDownLoadMembership():null} className={`member-button-global ${isButtonLock ? "member-button-global-inactive":"global-blue-button-controller-active"} flex-item d-flex m-r-12`} style={{height:"40px",borderRadius:"40px",pointerEvents:!isButtonLock?'auto':'none'}}>
                      <p className="flex-item fs-14 font-weight-600">Download XLX</p>
                    </div>
                  )
                  }
                {
                  props.moreAction == "Select-Membership" && window.innerWidth > 767 && (
                    selectMembershipView()
                  )
                }
                {
                  props.moreAction == "payment-action" && window.innerWidth > 767 && (
                    selectPaymentView()
                  )
                }
                <div onClick={(e)=>e.stopPropagation()} className="flex-item">
                  <div onClick={()=>toggleFilterView(props.filterType)} className="filter-button d-flex flex-item cursor-pointer" style={{background: isFilterOpen ? "#E33A34" : "#F7FDFF"}}>
                    {
                      !isFilterOpen ? (
                        <svg className="flex-item margin-auto" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M19.9586 9.87313H17.2568M13.6543 9.87313L5.54883 9.87313M8.25066 16.1777H5.54883M19.9586 16.1777L11.8531 16.1777" stroke="var(--darkBlue)" stroke-linecap="round"/>
                          <path d="M11.8524 16.1782C11.8524 15.1833 11.046 14.3769 10.0512 14.3769C9.05643 14.3769 8.25 15.1833 8.25 16.1782C8.25 17.173 9.05643 17.9795 10.0512 17.9795C11.046 17.9795 11.8524 17.173 11.8524 16.1782Z" stroke="var(--darkBlue)" stroke-linecap="round"/>
                          <path d="M17.2567 9.87349C17.2567 8.87865 16.4503 8.07217 15.4555 8.07217C14.4607 8.07217 13.6543 8.87865 13.6543 9.87349C13.6543 10.8683 14.4607 11.6748 15.4555 11.6748C16.4503 11.6748 17.2567 10.8683 17.2567 9.87349Z" stroke="var(--darkBlue)" stroke-linecap="round"/>
                        </svg>
                      ) : (
                        <svg className="flex-item margin-auto" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.31836 19.9795L19.3184 6.97949M19.3184 19.9795L6.31836 6.97949" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      )
                    }
                  </div>
                </div>
              </div>
            )
          }
        </div>
      </div>

      {
        props.moreAction == "Select-Membership" && window.innerWidth < 768 && (
          <div className="d-flex m-t-12">
            {selectMembershipView()}
          </div>
        )
      }

      <div onClick={(e)=>e.stopPropagation()} className="all-filter-container flex-item scaleFromTopToBottom" style={{padding: props.isSticky ? "0" : "12px 0 300px 12px", transition:"180ms", display: isFilterOpen ? "block" : "none"}}>
        <div className="w-full p-b-40 p-r-8" style={{overflowY:'auto',height:'40vh'}}>
          {
            localStorage.getItem("branchId") && (
              <div className="w-full">
                {
                  (props.searchType ==  "PT Reports" || props.searchType == "Personal Training") && (
                    <div className="w-full p-b-12">
                      <PersonalTrainingFilter headerView={true} completedSession={true} totalSession={true} />
                      <DateFilter />
                      <TrainerFilter headerView={true}/>
                    </div>
                  )
                }

                {
                  props.searchType == "by Name" && (
                    <div className="w-full p-b-12">
                      <DateFilter isReset={isReset} handleResetState={handleResetState} />
                      <div style={{visibility:'hidden'}}>
                      <ExpenseFilter/> {/*Will be on top*/}
                      <PaymentMode actionType={"filter"} />
                      </div>
                    </div>
                  )
                }

                {
                  props.searchType == "by Command" && (
                    <div className="w-full p-b-12">
                      <DateFilter isReset={isReset} handleResetState={handleResetState} />
                      <div style={{visibility:'hidden'}}>
                      <ExpenseFilter/> {/*Will be on top*/}
                      <PaymentMode actionType={"filter"} />
                      </div>
                    </div>
                  )
                }

                {
                  (props.searchType == "Enquiry") && (
                    <div className="w-full">
                      <EnquiryFilter  selectedGym={props.selectedGym}/>
                    </div>
                  )
                }
                
                {
                  (props.filterSection == "content-filter" || props.filterSection == "content-filter-db") && (
                    <div className="w-full">
                      {/* contentRole={props.contentRole} exerciseType={props.exerciseType} exerciseLevel={props.exerciseLevel} targetMuscle={props.targetMuscle} */}
                      <ContentFilter isReset={isReset} handleResetState={handleResetState} contentPrivacy={props.contentPrivacy} contentRole={props.contentRole} setParameterFilter={props.setParameterFilter} contentFilters={props.contentFilters} setDbFilter={props.filterSection == "content-filter-db" ? true : false} />
                    </div>
                  )
                }


                {
                  props.filterSection == "follow-up-filter" && (
                    <div className="w-full">
                      <FollowUpFilter selectedGym={props.selectedGym} handleSetFollowupFilterParams={props.handleSetFollowupFilterParams}/>
                    </div>
                  )
                }

                {
                  props.filterSection == "ads-filter" && (
                    <div className="w-full">
                      <AdsFilter headerView={true}/>
                    </div>
                  ) 
                }

                {
                  props.filterSection == "member-appointment-filter" && (
                    <div className="w-full">
                      <AppointmentFilter headerView={true}/>
                    </div>
                  ) 
                }

                {
                  props.filterSection == "member-filter" && (
                    <div className="w-full">
                      <Status getStatus={getStatus} isReset={isReset} handleResetState={handleResetState}/>
                      <div className="m-t-16" />
                      <Gender isReset={isReset} handleResetState={handleResetState}/>
                      <div className="m-t-20" />
                      <Birthday isReset={isReset} handleResetState={handleResetState}/>
                    </div>
                  )
                }

                {
                  props.filterSection == "member-list-filter" && (
                    <div className="w-full">
                      <MemberFilter/>
                      {/* <Status getStatus={getStatus}/> */}
                    </div>
                  )
                }

                {
                  props.filterSection == "payment-filter" && (
                    <div className="w-full">
                      <PaymentsFilter/>
                    </div>
                  )
                }
                
                {
                  props.filterSection == "planner-filter" && (
                    <div className="w-full"> 
                    
                      <PlannerFilter
                        plannerFilterStatus={plannerFilterStatus}
                        isReset={isReset}
                        handleResetState={handleResetState}
                      />
                    </div>
                  )
                }

                {
                  props.filterSection == "employee-filter" && (
                    <div className="w-full">
                      <Status getStatus={getStatus} isReset={isReset} handleResetState={handleResetState} />
                      <EmployeeFilter employeeFilterRole={props.employeeFilterRole} isReset={isReset} handleResetState={handleResetState} />
                    </div>
                  ) 
                }

                {
                  props.filterSection == "plan-membership-filter" && (
                    <Status getStatus={getStatus}/>
                  )
                }

              </div>
            )
          }

          {
            props.filterSection == "gym-db-filter" && (
              <GymFilter />
            )
          }

          {
            props.filterSection == "branch-filter" && (
              <BranchFilter branchFilters={props.branchFilters} isReset={isReset} handleResetState={handleResetState}/>
            )
          }

          {
            props.filterSection == "parameter-filter" && (
              <Parameter handleParameterType={handleParameterType} getParameterType={props.getParameterType} />
            )
          }


          {
            props.moreAction == "Select-Membership" && (
              <MemberShipFilter header={true} />
            )
          }

          
        </div>


        {
          (props.filterSection !== "parameter-filter") && (
            <div className="w-full d-flex space-between" style={{position:"absolute", bottom: 0, left:0, background:"#ffffff", padding: !props.isSticky && "12px", borderRadius:"0 0 12px 12px"}}>
              <div onClick={()=>ApplyFilter()} className="global-button-container global-button-container-active d-flex flex-item" style={{borderRadius:"20px", height: "40px", width:"60%"}}>
                <p className="flex-item fs-16">Apply Filter</p>
              </div>
              <p className="font-weight-400 fs-16 color-grey-06 flex-item m-l-20 m-r-20" style={{lineHeight:"16px"}}>OR</p>
              <div onClick={()=>ClearFilter()} className="global-button-container d-flex flex-item m-r-0" style={{borderRadius:"20px", height: "40px"}}>
                <p className="flex-item fs-16">Reset</p>
              </div>
            </div>
          )
        }
      </div>
      
      {
        !props.isSticky && window.innerWidth < 768 && props.filterSection != "gym-filter" && [
          window.innerWidth > 767 && filteredItems.length > 0 && (
            <div className="w-full p-t-12">
              {getAllFilteredItems()}
            </div>
          ),
          props.filterSection == "follow-up-filter" && (
            <div className="filter-desc-container m-t-16" style={{background: props.isSticky ? "#f5f5f5" : "#ffffff"}}>
              {/* {convertibilityType(props.Hot, props.Warm, props.Cold)} */}
              {/* <div className="m-t-8 m-b-8 w-full" style={{height:"1px", background:"#e8e8e8"}} /> */}
              <div className="w-full d-flex space-between">
                <p className="font-weight-700 flex-item">Clients ( <span className="color-dark-blue">{props.userFollowupCount}</span> ) - <span className="color-dark-blue">{props.totalFollowupCount}</span> Follow Ups</p>
                <div onClick={props.downloadFollowup?()=>props.downloadFollowup():null} className="member-button-global btn-center d-flex" style={{padding: "0 4px 0 8px", width:"80px", height: "30px", borderRadius:"15px", background: "#5d883c"}}>
                  <svg className="flex-item m-r-4" width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 8.68275L3.34575 6.02925L3.87675 5.48925L5.625 7.2375V0.75H6.375V7.2375L8.1225 5.49L8.65425 6.02925L6 8.68275ZM1.962 11.25C1.6165 11.25 1.32825 11.1345 1.09725 10.9035C0.86625 10.6725 0.7505 10.384 0.75 10.038V8.22075H1.5V10.038C1.5 10.1535 1.548 10.2595 1.644 10.356C1.74 10.4525 1.84575 10.5005 1.96125 10.5H10.0388C10.1538 10.5 10.2595 10.452 10.356 10.356C10.4525 10.26 10.5005 10.154 10.5 10.038V8.22075H11.25V10.038C11.25 10.3835 11.1345 10.6718 10.9035 10.9028C10.6725 11.1338 10.384 11.2495 10.038 11.25H1.962Z" fill="white"/>
                  </svg>
                  <p className="font-weight-700 flex-item" style={{color:"#ffffff"}}>.xlsx</p>
                </div>
              </div>
            </div>
          )
        ]
      }


      {
        isFilterOpen && props.isSticky && (
          <div className="m-t-12 w-full" style={{height:"1px", background:"#e8e8e8"}} />
        )
      }
     
    </div>
  )
}

export default SearchFilter;